import React, {FC} from 'react';
import {ReactComponent as ArrayIcon} from '../../../../../assets/main/groups/main-table/array.svg';
import {ReactComponent as BasketIcon} from '../../../../../assets/main/profile-box/basket.svg';
import {ReactComponent as TooltipIcon} from '../../../../../assets/main/groups/main-top/tooltip.svg';
import {PaymentItem} from "features/model/types/payments/paymentsSchema";
import {deletePayment} from "features/model/service/delete-payments/delete-payments";
import {useAppDispatch} from "common/hook";
import {Link} from "react-router-dom";
import {fetchPayments} from "features/model/service/payments/payments";

interface PaymentItemsProps {
    payment: PaymentItem;
}


export const PaymentItems: FC<PaymentItemsProps> = ({payment}) => {
    const dispatch = useAppDispatch();
    if (!payment) {
        return null;
    }


    const handleDeleteClick = async (paymentId: number) => {
        if (window.confirm("Вы уверены, что хотите удалить этот платеж?")) {
            try {
                await dispatch(deletePayment(paymentId));
                await dispatch(fetchPayments({}));
            } catch (error) {
                console.error("Произошла ошибка:", error);
            }
        }
    };


    const creditCardLink = payment.paymentMethod === "credit_card" ? (
        payment.redirectUrl ? (
            <a href={payment.redirectUrl} target="_blank">{payment.title}</a>
        ) : (
            <p>{payment.title}</p>
        )
    ) : null;


    const bankTransferLink = payment.paymentMethod === "bank_transfer" ? (
        payment.trackingId ? (
            <Link to={`/buy-course/${payment.id}/bank-transfer/${payment.trackingId}`}>{payment.title}</Link>
        ) : (
            <p>{payment.title}</p>
        )
    ) : null;


    return (
        <div className="row">
            <div className="col payment-num-col full-width-mobile">
                <p>{creditCardLink || bankTransferLink}</p>
                <p className="sub-data">{payment.course}</p>
            </div>

            <div className="col state-col full-width-mobile">
               <span
                   className={`complited-count state-view ${payment.status === "pending" ? "pending" : (payment.status === "failed" ? "not-done" : "")}`}>
                    {payment.statusTitle}
                </span>
                <p className="sub-data">{payment.paymentMethodTitle}</p>
            </div>
            <div className="col price-col align-right full-width-mobile">
                <p className={`price${payment.price === 0 ? " p-icon inactive" : ""}`}>
                    <strong> {payment.price} {payment.currency}</strong>
                    {payment.price === 0 ?
                        <div className="icon new-tooltip">
                            <span className="icon pointer-elem">
                                <TooltipIcon/>
                            </span>
                            <div className="tooltip-text">Tooltip Text Description</div>
                        </div>
                        :
                        <span className="icon tooltip"></span>
                    }
                </p>
                <time className="time sub-data">
                    {payment.date}
                </time>
            </div>

            <div className="col delete-col">
                {payment.status === 'pending' && payment.paymentMethod === "bank_transfer" && payment.canDelete && (
                    <span
                        className="delete-tbl-row"
                        onClick={() => handleDeleteClick(payment.id)}
                    >
                        <BasketIcon/>
                    </span>
                )}
            </div>
            <div className="col btn-link-col">
                {payment.paymentMethod === "bank_transfer" && payment.trackingId &&
                    <Link className="circle-arrow-btn"
                          to={`/buy-course/${payment.id}/bank-transfer/${payment.trackingId}`}>
                        <ArrayIcon/>
                    </Link>
                }
            </div>
        </div>
    );
};

